import {useEffect} from 'react';

const WARN_ON_UNLOAD_FLAG = '__warnOnUnloadActive';
const WARN_ON_UNLOAD_CHANGE_EVENT = 'warn-on-unload-change';

export function useWarnOnUnload(active) {
  useEffect(() => {
    const nextValue = Boolean(active);
    const previousValue = window[WARN_ON_UNLOAD_FLAG];

    window[WARN_ON_UNLOAD_FLAG] = nextValue;

    if (previousValue !== nextValue) {
      window.dispatchEvent(
        new CustomEvent(WARN_ON_UNLOAD_CHANGE_EVENT, {
          detail: {active: nextValue},
        })
      );
    }

    if (!nextValue) return;

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);

      if (window[WARN_ON_UNLOAD_FLAG] === nextValue) {
        window[WARN_ON_UNLOAD_FLAG] = false;
        window.dispatchEvent(
          new CustomEvent(WARN_ON_UNLOAD_CHANGE_EVENT, {
            detail: {active: false},
          })
        );
      }
    };
  }, [active]);
}
